import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import DashboardLayout from '../components/DashboardLayout';
import { useAuth } from '../contexts/AuthContext';

const WhiteLabelContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 1rem;
  
  @media (max-width: 768px) {
    padding: 0.5rem;
  }
`;

const Title = styled.h1`
  font-size: 1.8rem;
  margin-bottom: 2rem;
  color: ${props => props.theme.colors.primary};
  border-bottom: 1px solid ${props => props.theme.colors.primary};
  padding-bottom: 0.5rem;
  
  @media (max-width: 768px) {
    font-size: 1.4rem;
    margin-bottom: 1rem;
  }
`;

const Section = styled.div`
  background-color: #0a0a0a;
  border-radius: 4px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    padding: 1rem;
    margin-bottom: 1rem;
  }
`;

const SectionTitle = styled.h2`
  font-size: 1.4rem;
  margin-bottom: 1.5rem;
  color: ${props => props.theme.colors.primary};
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 1.2rem;
    margin-bottom: 1rem;
  }
`;

const ContentText = styled.p`
  margin-bottom: 1.5rem;
  line-height: 1.8;
  font-size: 1rem;
`;

const HighlightBox = styled.div`
  margin: 2rem 0;
  padding: 1.5rem;
  background-color: rgba(254, 189, 35, 0.1);
  border-radius: 6px;
  border-left: 4px solid ${props => props.theme.colors.primary};
  
  @media (max-width: 768px) {
    padding: 1rem;
    margin: 1.5rem 0;
  }
`;

const ContactInfo = styled.div`
  margin-top: 2rem;
  text-align: center;
  font-size: 1.1rem;
  font-weight: bold;
  color: ${props => props.theme.colors.primary};
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const TwitterHandle = styled.span`
  font-weight: bold;
  color: ${props => props.theme.colors.primary};
`;

const BenefitsList = styled.ul`
  margin: 1.5rem 0;
  padding-left: 1.5rem;
  
  li {
    margin-bottom: 0.8rem;
    line-height: 1.6;
  }
`;

const WhiteLabelPage: React.FC = () => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  
  // Redirect if not authenticated
  React.useEffect(() => {
    if (!isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);
  
  return (
    <DashboardLayout activeMenuItem="whitelabel">
      <WhiteLabelContainer>
        <Title>WhiteLabel Solution</Title>
        
        <Section>
          <SectionTitle>Welcome to the $Voovo X Trading Bot WhiteLabel Program</SectionTitle>
          
          <ContentText>
            Voovo is excited to offer WhiteLabel solutions tailored for your project. Our advanced 
            Trading Bot can be seamlessly integrated into your platform, enabling you to automate 
            your X trading account and transform it into a fully functional trading bot for 
            Solana-based cryptocurrencies. This solution allows you to generate revenue through 
            trading fees.
          </ContentText>
          
          <HighlightBox>
            <ContentText>
              By implementing our WhiteLabel Trading Utility, you will earn 0.7% of the total value 
              of all swaps and trades processed through your integrated system. Your X account will 
              operate with the same capabilities as our primary X.com/Voovo_study bot utility. The Utility 
              charges a total fee of 1% per transaction, with 0.3% allocated to Voovo to facilitate 
              $Voovo token buybacks.
            </ContentText>
          </HighlightBox>
          
          <SectionTitle>Benefits of Our WhiteLabel Solution</SectionTitle>
          
          <BenefitsList>
            <li>Generate revenue through trading fees (0.7% of all transactions)</li>
            <li>Fully automated trading system for your community</li>
            <li>Custom branding under your project name</li>
            <li>Real-time analytics and reporting</li>
            <li>Technical support and maintenance included</li>
            <li>Seamless integration with your existing platforms</li>
            <li>Regular updates with new features and improvements</li>
          </BenefitsList>
          
          <ContactInfo>
            To apply for our WhiteLabel solution, please send a direct message to our X profile,{' '}
            <TwitterHandle>@Voovo_study</TwitterHandle>
          </ContactInfo>
        </Section>
      </WhiteLabelContainer>
    </DashboardLayout>
  );
};

export default WhiteLabelPage; 